<template>
    <div class="table-responsive">
        <table class="table table-hover no-overflow">
            <thead>
                <tr>
                    <th @click="$emit('sort', 'loanApplication.loanApplicationsReferenceNumber')">
                        Folio solicitud
                        <span v-if="amortizationStore.sortKey === 'loanApplication.loanApplicationsReferenceNumber'">
                            <i :class="amortizationStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'prospectus.referenceNumber')">
                        Folio prospecto
                        <span v-if="amortizationStore.sortKey === 'prospectus.referenceNumber'">
                            <i :class="amortizationStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'quotations.quotationsReferenceNumber')">
                        Folio cotización
                        <span v-if="amortizationStore.sortKey === 'quotations.quotationsReferenceNumber'">
                            <i :class="amortizationStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'name')">
                        Nombre
                        <span v-if="amortizationStore.sortKey === 'name'">
                            <i :class="amortizationStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th @click="$emit('sort', 'personType.peopleTypeName')">
                        Tipo de persona
                        <span v-if="amortizationStore.sortKey === 'personType.peopleTypeName'">
                            <i :class="amortizationStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                        </span>
                        <span v-else>
                            <i class="fas fa-sort"></i>
                        </span>
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="amortizations.length > 0">
                    <tr v-for="amortization in amortizations" :key="amortization.id">
                        <td>{{ amortization.loanApplication.loanApplicationsReferenceNumber }}</td>
                        <td>{{ amortization.prospectus.referenceNumber }}</td>
                        <td>{{ amortization.quotations.quotationsReferenceNumber }}</td>
                        <td>{{ getName(amortization) }}</td>
                        <td>{{ amortization.personType.peopleTypeName }}</td>
                        <td>
                            <PrimaryButton class="btn-success" @click="$emit('generate', amortization)"
                                data-toggle="modal" data-target="#amortizationModal">
                                <i class="fa fa-download"></i>
                            </PrimaryButton>
                        </td>
                    </tr>
                </template>
                <tr v-else>
                    <td colspan="10" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useAmortizationStore } from '@/pinia/LoanApplications/Legal/useAmortizationStore.module';

const props = defineProps({
    amortizations: {
        type: Array,
        required: true,
        default: () => []
    }
});

/**
 * Abre el modal para generar la tabla de amortización (Boton de la tabla)
 * Acción del ordenamiento de las columnas (Ordenamiento)
 * Acciónes de la tabla
 */
const emit = defineEmits(['sort', 'generate']);

const amortizationStore = useAmortizationStore();

const getName = (item) => {
    if (item.prospectus.generalInfo.businessName === null) {
        return `${item.prospectus.generalInfo.firstName} ${item.prospectus.generalInfo.lastName} ${item.prospectus.generalInfo.mothersMaidenName}`;
    } else {
        return `${item.prospectus.generalInfo.businessName}`;
    }
}
</script>